var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"merge-container"},[_c('button',{staticClass:"oeamtc-button",attrs:{"disabled":_vm.disabled,"title":"Fahrten zusammenführen"},on:{"click":_vm.onMergeButton}},[_c('icon-link',{attrs:{"x":"12","y":"12","height":"14","width":"14","viewBox":"0 0 16 16"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }